import { Role, RoleType } from '@lockton-apps/shared/interfaces';

// guard helpers

export function isBrokerOrHigher(role: RoleType) {
  return role <= Role.Broker;
}

export function isLeadBrokerOrHigher(role: RoleType) {
  return role <= Role.LeadBroker;
}

export function isAdmin(role: RoleType) {
  return role === Role.Administrator;
}

export function isContact(role: RoleType) {
  return !isBrokerOrHigher(role);
}
